export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Gestão Completa de Licitações',
      description: 'Da prospecção de editais até a entrega final e recebimento.'
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Assessoria Jurídica Especializada',
      description: 'Impugnações, recursos, pareceres e defesas em Tribunais de Contas.'
    },
    {
      icon: 'ri-file-text-line',
      title: 'Gestão de Contratos',
      description: 'Reequilíbrios econômicos, aditivos e controle de prazos.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Consultoria Sob Demanda',
      description: 'Análise pontual de editais e riscos para sua tomada de decisão.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-primary mb-4">
            Soluções para Sua Empresa
          </h2>
          <p className="text-lg text-text-grey max-w-3xl mx-auto">
            Serviços completos para sua empresa vencer licitações e gerenciar contratos públicos com segurança.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-light-grey p-8 rounded-lg hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-primary rounded-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-semibold text-primary mb-4">
                {service.title}
              </h3>
              <p className="text-text-grey leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
